// NPM Imports
import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components Imports
import ChartHeader from "../ChartHeader";

/**
 * TableChart => used to show the data in tabular form
 *  Need to pass the followings props,
 *  1. 'showHeader'       - to show the top table header
 *  2. 'headerTitle'      - table top header title
 *  3. 'showTableHeading' - flag to show the table head part
 *  4. 'tableHeader'      - table head columns
 *  5. 'tableRows'        - table rows
 *  6. 'extraData'        - to show an extra data on top (ex: total value)
 */
const TableChart = props => {
  const {
    showHeader,
    headerTitle,
    tableRows,
    showTableHeading,
    extraData: { title, value } = {},
    tableHeader,
  } = props;

  const _getTableHeadings = thData =>
    thData.map(heading => (
      <span
        className={`tablechart-table-th ${heading.className}`}
        key={heading.label}>
        {heading.label}
      </span>
    ));

  const _decideTable = () => {
    let tablebodyClassName = "tablechart-table-body ";
    if (props.extraData) {
      tablebodyClassName += " updated-height ";
    }

    if (tableRows.length === 0) {
      return (
        <span>
          <span className="tablechart-table-emptyimg">
            <FontAwesomeIcon icon={["far", "chart-pie"]} />
          </span>
          <span className="tablechart-table-emptytext">
            No data to display.
          </span>
        </span>
      );
    }

    return (
      <Fragment>
        {/* Table Extra Heading */}
        {props.extraData ? (
          <div className="tablechart-table-extradata">
            <span className="tablechart-extradata-title">{title}</span>
            <span className="tablechart-extradata-value">{value}</span>
          </div>
        ) : null}
        {/* Table Head */}
        <div className="tablechart-table-head">
          {showTableHeading ? _getTableHeadings(tableHeader) : null}
        </div>
        {/* Table Body */}
        <div className={tablebodyClassName}>{tableRows}</div>
      </Fragment>
    );
  };

  const _decideHeader = () => {
    if (showHeader) {
      return (
        <ChartHeader
          title={headerTitle}
          dateTitle="Jan 01, 2019 July 01, 2019"
        />
      );
    }
    return null;
  };

  console.debug("Rendring the TableChart....");
  return (
    <div className="tablechart-container">
      {_decideHeader()}
      <div
        className={`tablechart-table-wrapper ${
          tableRows.length === 0 ? "tablechart-table-nodata" : ""
        }`}>
        {_decideTable()}
      </div>
    </div>
  );
};

export default TableChart;



// WEBPACK FOOTER //
// ./src/components/DashboardWrapper/Charts/TableChart/index.js